import * as React from "react";
import clsx from "clsx";
import { ChevronDown } from "lucide-react";
import { SubcollectionDropdown } from "@/modules/snapshots/snapshotCollections/components/breadcrumb/SubcollectionDropdown";

interface Props {
  snapshotCollectionId: string;
  subcollectionId: string | undefined;
  activeSubcollectionName: string;
  activeSubcollectionCount: number | undefined;
  isOwner: boolean;
  contractFamilyProjection: boolean;
}

export const SubcollectionControl: React.FC<Props> = ({
  snapshotCollectionId,
  subcollectionId,
  activeSubcollectionName,
  activeSubcollectionCount,
  isOwner,
  contractFamilyProjection,
}) => (
  <SubcollectionDropdown
    snapshotCollectionId={snapshotCollectionId}
    allCount={activeSubcollectionCount}
    isOwner={isOwner}
    contractFamilyProjection={contractFamilyProjection}
    trigger={
      <button
        type="button"
        className={clsx(
          "flex items-center gap-1.5 rounded-full border bg-white px-3 py-1 text-sm text-gray-900 shadow-sm transition-colors hover:bg-gray-50",
          subcollectionId ? "border-coral/70" : "border-gray-300",
        )}
      >
        <span className="text-xs font-medium uppercase tracking-wide text-gray-600">Sub-collection:</span>
        <span className="font-semibold">{activeSubcollectionName}</span>
        {typeof activeSubcollectionCount === "number" && (
          <span className="rounded-full bg-gray-900 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white">
            {activeSubcollectionCount}
          </span>
        )}
        <ChevronDown className="h-4 w-4 text-gray-500" aria-hidden="true" />
      </button>
    }
  />
);
